import * as React from 'react';
import { Helper } from '../../../../../Helper';
import DateTimeService from '../../../../../services/DateTimeService';
import * as styles from './CanteenMenuItem.css';
import { IAReader } from '../../../../reader/Reader';

export interface IProps {
  sizeUnit: number;
  textColor: string;
  title: string;
  content: string;
  startDate: string;
  endDate: string;
  location: string;
  dayInMonth: string;
  dayOfTheWeek: string;
}

export interface IState {
}

export class CanteenMenuItem extends React.Component<IProps, IState> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private itemId: string;

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.itemId = Helper.getRandomStringKey();
  }

  public componentDidMount(): void {
    this.setFontSizes();
  }

  private setFontSizes(): void {
    try {
      var css: any = document.createElement('style');
      css.type = 'text/css';
      css.appendChild(document.createTextNode(`.ql-snow .ql-editor p { font-size: ${this.props.sizeUnit * 2.8}px !important; lineHeight: ${this.props.sizeUnit * 4}px !important}`));
      css.appendChild(document.createTextNode(`.ql-snow .ql-editor li { font-size: ${this.props.sizeUnit * 2.8}px !important; lineHeight: ${this.props.sizeUnit * 4}px !important}`));
      css.appendChild(document.createTextNode(`.ql-snow .ql-editor h1 { font-size: ${this.props.sizeUnit * 5}px !important}`));
      css.appendChild(document.createTextNode(`.ql-snow .ql-editor h2 { font-size: ${this.props.sizeUnit * 3.5}px !important}`));
      document.getElementsByTagName("head")[0].appendChild(css);
    } catch (error) {
      console.log(`%c${error}`, 'background: red; color: #ffffff')
    }
  }

  public render(): JSX.Element {
    const canteenMenuItemDivs = document.getElementById(`IA_canteenMenuItem_${this.itemId}`);
    let height = 0;
    try {
      if (canteenMenuItemDivs) {
        let canteenMenuItemContentElements: any = document.getElementsByClassName(`IA_canteenMenuItemContentElement_${this.itemId}`);
        if (canteenMenuItemContentElements?.length > 0) {
          height = canteenMenuItemDivs.clientHeight;
          const headlineDateDiv = document.getElementById(`IA_Headline`)
          if (headlineDateDiv) {
            height -= headlineDateDiv.clientHeight;
            height -= (this.props.sizeUnit * 2.5)
          }
          const headerDateDiv = document.getElementById(`IA_headerDate_${this.itemId}`)
          if (headerDateDiv) {
            height -= headerDateDiv.clientHeight;
            height -= (this.props.sizeUnit * 2)
          }
          const titleDiv = document.getElementById(`IA_title_${this.itemId}`)
          if (titleDiv) {
            height -= titleDiv.clientHeight;
            height -= this.props.sizeUnit
          }
          const timeDiv = document.getElementById(`IA_time_${this.itemId}`)
          if (timeDiv) {
            height -= timeDiv.clientHeight;
          }
          const locationDiv = document.getElementById(`IA_location_${this.itemId}`)
          if (locationDiv) {
            height -= locationDiv.clientHeight;
          }
          let contentHeight = 0;
          for (let canteenMenuItemContentElement of canteenMenuItemContentElements) {
            contentHeight += canteenMenuItemContentElement.clientHeight;
            if (canteenMenuItemContentElement.nodeName === "UL") {
              contentHeight += (this.props.sizeUnit * 2);
            }
            if (height > contentHeight) {
              canteenMenuItemContentElement.style.opacity = 1;
            } else {
              canteenMenuItemContentElement.style.opacity = 0;
            }
          }
        }
      }
    } catch (error) {
      console.log(`%c${error}`, 'background: red; color: #ffffff')
    }
    return (
      <div
        id={`IA_canteenMenuItem_${this.itemId}`}
        className={styles.IA_canteenMenuItem}
        style={{
          color: this.props.textColor
        }}
      >
        <div
          id={`IA_headerDate_${this.itemId}`}
          style={{
            opacity: 0.7
          }}
        >
          <div
            style={{
              fontSize: this.props.sizeUnit * 4,
            }}
          >
            {this.props.dayInMonth}
          </div>
          <div
            style={{
              fontSize: this.props.sizeUnit * 1.5,
              marginBottom: this.props.sizeUnit * 2
            }}
          >
            {this.props.dayOfTheWeek?.toUpperCase()}
          </div>
        </div>
        {this.props.title &&
          <div
            id={`IA_title_${this.itemId}`}
            className={styles.IA_title}
            style={{
              fontSize: this.props.sizeUnit * 3,
              marginBottom: this.props.sizeUnit
            }}
          >
            {this.props.title}
          </div>
        }
        {this.props.startDate &&
          <div
            id={`IA_time_${this.itemId}`}
            className={styles.IA_byline}
            style={{
              fontSize: this.props.sizeUnit * 2,
              marginBottom: this.props.sizeUnit * 0.5,
              opacity: 0.8
            }}
          >
            {/* <IAIcon
              title="Calendar"
              size={this.props.sizeUnit * 3}
              color={this.props.textColor}
              style={{
                float: "left",
              }}
            /> */}
            <div style={{
              float: "left",
              // marginLeft: this.props.sizeUnit,
            }}>
              {`${this.dateTimeService.ConvertToHHMM(this.props.startDate)} - ${this.dateTimeService.ConvertToHHMM(this.props.endDate)}`}
            </div>
          </div>
        }
        {this.props.location &&
          <div
            id={`IA_location_${this.itemId}`}
            className={styles.IA_byline}
            style={{
              fontSize: this.props.sizeUnit * 2,
              marginBottom: this.props.sizeUnit * 0.5,
              opacity: 0.8
            }}
          >
            {/* <IAIcon
              title="Address"
              size={this.props.sizeUnit * 3}
              color={this.props.textColor}
              style={{
                float: "left",
              }}
            /> */}
            <div style={{
              float: "left",
              //  marginLeft: this.props.sizeUnit
            }}>
              {this.props.location}
            </div>
          </div>
        }
        {this.props.content?.length > 0 &&
          <div
            id={`IA_text_${this.itemId}`}
            className={styles.IA_text}
            style={{
              fontSize: this.props.sizeUnit * 2,
              height: height
            }}
          >
            <IAReader
              useNewEditor={false}
              content={this.props.content}
              style={{
                position: "relative",
                fontSize: `${this.props.sizeUnit * 2.8}px`,
                lineHeight: `${this.props.sizeUnit * 4}px`,
                borderWidth: 1
              }}
            />
          </div>
        }
      </div>
    )
  }


}